import React, { useContext, useCallback } from 'react';
import style from './style.module.less';
import messages from './messages';
import { Input } from 'ui-components/components/input';
import { FilterEditorContext } from '../../context';
import { FormattedMessage } from 'react-intl';

const allowedCount = 2000;

const FilterNameAndDescription = () => {
  const { filterName, setFilterName, filterDescription, setFilterDescription } = useContext(FilterEditorContext);

  const onValueChange = useCallback(
    (e) => {
      setFilterDescription(e?.target?.value);
    },
    [setFilterDescription],
  );

  const nameLabelId = 'filter-name-label';
  const descriptionLabelId = 'filter-description-label';

  return (
    <div className={style.wrapper}>
      <div className={style.header}>
        <FormattedMessage {...messages.filtersetEditorHeader} />
      </div>
      <div className={style['entry-wrapper']}>
        <div id={nameLabelId}>
          <FormattedMessage {...messages.filtersetEditorNameLabel} />
        </div>
        <div>
          <Input aria-labelledby={nameLabelId} onChange={setFilterName} value={filterName} />
        </div>
      </div>
      <div className={style['entry-wrapper-stacked']}>
        <div id={descriptionLabelId}>
          <FormattedMessage {...messages.filtersetEditorDescriptionLabel} />
        </div>
        <div>
          <textarea
            aria-labelledby={descriptionLabelId}
            className={style['text-area-input']}
            maxLength={allowedCount}
            onChange={onValueChange}
            value={filterDescription}
          />
        </div>
      </div>
      <div className={style.supplemental}>
        <FormattedMessage
          {...messages.filtersetEditorSupplemental}
          values={{
            b: (chunks) => <span className={style.bolded}>{chunks}</span>,
          }}
        />
      </div>
    </div>
  );
};

export default FilterNameAndDescription;
